import { themeManager } from './theme.js';

// Menu management
export const menuManager = {
    init() {
        const menuButton = document.getElementById('menuButton');
        const menuModal = document.getElementById('menuModal');
        const closeMenuBtn = document.getElementById('closeMenuBtn');
        const themeToggle = document.getElementById('themeToggle');

        if (!menuButton || !menuModal || !closeMenuBtn || !themeToggle) {
            console.error('Menu elements not found');
            return;
        }

        // Open menu
        menuButton.addEventListener('click', () => {
            menuModal.classList.remove('hidden');
            document.body.style.overflow = 'hidden'; // Prevent scrolling when menu is open
        });

        // Close menu
        closeMenuBtn.addEventListener('click', () => {
            menuModal.classList.add('hidden');
            document.body.style.overflow = ''; // Restore scrolling
        });

        // Close menu when clicking outside
        menuModal.addEventListener('click', (e) => {
            if (e.target === menuModal) {
                menuModal.classList.add('hidden');
                document.body.style.overflow = ''; // Restore scrolling
            }
        });

        // Prevent menu from closing when clicking inside
        const menuContent = menuModal.querySelector('.bg-white');
        if (menuContent) {
            menuContent.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }

        // Handle theme toggle
        themeToggle.addEventListener('click', () => {
            const isDark = themeManager.toggleTheme();
            this.updateThemeToggleState(isDark);
        });

        // Set initial theme toggle state
        this.updateThemeToggleState(themeManager.isDarkMode());
    },

    updateThemeToggleState(isDark) {
        const themeToggle = document.getElementById('themeToggle');
        if (!themeToggle) return;

        const toggleCircle = themeToggle.querySelector('span:last-child');
        if (!toggleCircle) return;

        // Update toggle position
        toggleCircle.style.transform = isDark ? 'translateX(1.25rem)' : 'translateX(0)';
        
        // Update toggle background color
        themeToggle.classList.toggle('bg-gray-200', !isDark);
        themeToggle.classList.toggle('bg-gray-700', isDark);
    }
}; 